import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsAccesshabitat(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsAccesshabitat(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsAccesshabitat - ', e);
                throw e;
            });
    };
}
export { getLogsAccesshabitat };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsAccesshabitat/actions.js